<template>
  <section class="banner">
    <div class="banner__bg">
      <video
        v-if="data.videoUrl"
        class="banner__bg-video"
        autoplay
        muted
        playsinline
        loop
        :src="`${setImageUrl()}${data.videoUrl}`"
      />
      <img 
        v-else 
        src="../assets/img/banner.jpg"
        alt="main-banner"
      >
    </div>
    <div class="container">
      <Scroll 
        v-if="!$store.getters.isMobile"
        class="banner__scroll-icon"
      />
      <ScrollMobile 
        v-if="$store.getters.isMobile"
        class="banner__scroll-icon_mobile"
      />
      <header class="banner__header">
        <HeaderLogo />
        <div class="banner__header-text">
          <LogoMini class="banner__header-logo-mini" />
          Priceless Music
        </div>
      </header>

      <div class="banner__body">
        <div class="banner__body-content">
          <h1 class="banner__title" v-html="data.title" />
          <div class="banner__description">
            {{ data.description }}
          </div>
        </div>

        <div 
          class="banner__button"
          @click="showModal"
        >
          <Lines class="banner__button_left-icon" />
          <span>Поділитися ідеєю</span>
          <Lines class="banner__button_right-icon" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>

  import HeaderLogo from '@/assets/svg/header-logo.svg'
  import LogoMini from '@/assets/svg/logo-mini.svg'
  import Lines from '@/assets/svg/lines.svg'
  import Scroll from '@/assets/svg/scroll.svg'
  import ScrollMobile from '@/assets/svg/scroll-mobile.svg'
  export default {
    name: 'MainBlock',

    components: { HeaderLogo, Lines, Scroll, ScrollMobile, LogoMini },

    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    },
    mounted () {
      this.setImageUrl()
    },

    methods: {
      setImageUrl () {
        return process.env.VUE_APP_API
      },
      showModal () {
        this.bus.$emit('showModal')
      }
    }
  }
</script>

<style lang="scss">
.banner {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100vh;
  overflow: hidden;

  .container {
    position: relative;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-grow: 1;
    z-index: 1;
    padding: 42px 40px;

    @include tablet {
      padding: 42px 24px;
    }

    @include mobile {
      padding: 16px;
    }
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg {
      width: 200px;
      height: 36px;

      @include mobile {
       width: 115px;
       height: 20px;
      }
    }

    &-text {
      color: $c-white;
      font-size: 46px;
      line-height: 1.34;
      display: flex;
      align-items: center;
      
      @include mobile {
        font-size: 18px;
      }

      svg {
        margin-right: 10px;
      }
    }

    &-logo-mini {
      width: inherit !important;
    }
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    &::before {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: '';
      background-color: rgba(0, 0, 0, 0.4);
      z-index: 1;
    }

    img,
    video {
      position: relative;
      height: 100%;
      min-width: 100%;
      
      @include mobile {
        left: -50%;
      }

      @include object-fit-cover();
    }
  }

  &__scroll-icon {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);

    @include tablet {
      right: 24px;
    }

    &_mobile {
      position: absolute;
      left: 50%;
      bottom: 20px;
      transform: translateX(-50%);
      z-index: 1;
    }
  }

  &__body {
    display: flex;
    align-items: flex-end;
    flex-direction: column;

    @include tablet {
      flex-grow: 1;
    }

    @include mobile {
      justify-content: center;
    }

    &-content {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      padding-right: 20px;
      margin-bottom: 50px;

      @include tablet {
        padding-right: 50px;
        flex-wrap: wrap;
        margin: auto;
      }

      @include mobile {
        padding-right: 0;
        margin: 0;
      }
    }
  }

  &__title {
    color: $c-white;

    @include tablet {
      margin-bottom: 40px;
    }

    span {
      color: $c-red;
    }
  }

  &__description {
    width: 100%;
    max-width: 363px;
    color: $c-white;
    font-size: 22px;
    line-height: 1.34;
    padding-bottom: 10px;

    @include tablet {
      margin-left: auto;
    }

    @include mobile {
      font-size: 14px;
      max-width: 187px;
    }
  }

  &__button {
    width: 100%;
    max-width: 461px;
    margin-right: -40px;
    display: flex;
    align-items: center;
    cursor: pointer;

    @include tablet {
      margin-top: auto;
    }

    @include mobile {
      max-width: 221px;
      margin-top: 24px;
    }

    span {
      font-size: 22px;
      line-height: 1.2;
      font-weight: 500;
      text-transform: uppercase;
      color: $c-white;
      white-space: nowrap;
      padding-left: 14px;
      padding-right: 11px;

      @include mobile {
        font-size: 14px;
        line-height: 16px;
      }
    }

    svg {
      height: 16px;
    }

    &_left-icon {
      width: 26px;

      @include mobile {
        width: 115px;
      }
    }
  }
}
</style>
